









import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { AcgnTitle, AcgnAuditStep, AcgnUpload } from '@acgn/herm/src/ui';
import { AttributeMixin, RenderMenuMixin } from '@/mixins';
import { AcgnFormContent, AcgnFormTitle, AcgnTaskMenu, AcgnGroupEdit } from '@/components/';
import { AcgnTableTask } from './components/';
import { namespace } from 'vuex-class';
import { complexClone } from '@acgn/herm/src/util/serialize';
import { getComicUploadImageSts } from '@/api/ossClient';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import event from '@acgn/herm/src/util/event';
import { Tabs, TabPane } from 'element-ui';

const WorkerAction = namespace('desk/worker').Action;

interface ComicDetailType { // 编辑结构类型
  name: string; // 名称
}

// 组件申明
@Component({
  components: {
    AcgnTitle,
    AcgnAuditStep,
    AcgnFormContent,
    AcgnFormTitle,
    AcgnTableTask,
    AcgnUpload,
    AcgnTaskMenu,
    AcgnGroupEdit,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  mixins: [AttributeMixin, RenderMenuMixin]
})

/**
 * 项目代办
 */
export default class ComicDetail extends Vue {
  @WorkerAction private createComic: any; // 创建漫画
  @WorkerAction private updateComic: any; // 编辑漫画
  @WorkerAction private projectDetail: any; // 漫画项目列表

  private formData: ComicDetailType = {
    name: ''
  };
  private comicId: any = 0;

  private eventSta: any = [
    {
      value: 1,
      name: '进行中'
    },
    {
      value: 2,
      name: '已完成'
    }
  ]; // 章节列表

  private searchForm: any = { // 头部筛选项
    name: '',
    username: '',
    page: 1
  };

  private activeName: any = 'second';

  private manageGroupList: any = [
    {
      id: 1,
      name: '项目待办',
      icon: 'ift-project_2',
      url: 'desk-workerDetail',
      belong: 'worker',
      selected: true,
    }
  ]; // 选中的管理组

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-task-menu authorityCode="3003" source="worker" manageGroupList={this.manageGroupList}></acgn-task-menu>
    );
  }

  // 获取表单验证规则
  private get rules() {
    const rules = {
      name: [
        { required: true, message: '标题不可为空', trigger: 'blur' }
      ]
    };

    return rules;
  }

  private created() {
    this.comicId = this.$route.params.id;
  }

  private handleClick(tab: any) {
    // console.log(tab);
  }

  // 获取状态
  private getStadius(row: any) {
    return (
      <span class="detail-sta">已过审</span>
    );
  }

  // 返回列表
  private goBack() {
    this.$router.back();
  }
}
